// Rising hearts behind the landing hero. Adapted from the particle field in
// the 21st.dev "Pricing Cards" component (lyanchouss), drawn as small hearts.
type Heart = { x: number; y: number; v: number; o: number; s: number; drift: number }

export function heartPath(ctx: CanvasRenderingContext2D, x: number, y: number, size: number): void {
  const s = size / 2
  ctx.beginPath()
  ctx.moveTo(x, y + s * 0.6)
  ctx.bezierCurveTo(x - s * 1.2, y - s * 0.3, x - s * 0.5, y - s * 1.3, x, y - s * 0.45)
  ctx.bezierCurveTo(x + s * 0.5, y - s * 1.3, x + s * 1.2, y - s * 0.3, x, y + s * 0.6)
  ctx.closePath()
}

export function startHearts(canvas: HTMLCanvasElement): () => void {
  const ctx = canvas.getContext('2d')
  if (!ctx || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return () => {}

  let hearts: Heart[] = []
  let raf = 0
  let width = 0
  let height = 0

  const make = (fromBottom = false): Heart => ({
    x: Math.random() * width,
    y: fromBottom ? height + Math.random() * 40 : Math.random() * height,
    v: Math.random() * 0.35 + 0.12,
    o: Math.random() * 0.3 + 0.08,
    s: Math.random() * 10 + 6,
    drift: (Math.random() - 0.5) * 0.25,
  })

  const resize = () => {
    const rect = canvas.parentElement?.getBoundingClientRect()
    width = Math.max(1, Math.floor(rect?.width ?? window.innerWidth))
    height = Math.max(1, Math.floor(rect?.height ?? window.innerHeight))
    const dpr = Math.min(window.devicePixelRatio || 1, 2)
    canvas.width = Math.floor(width * dpr)
    canvas.height = Math.floor(height * dpr)
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
    hearts = Array.from({ length: Math.floor((width * height) / 26000) }, () => make())
  }

  const draw = () => {
    ctx.clearRect(0, 0, width, height)
    for (const heart of hearts) {
      heart.y -= heart.v
      heart.x += heart.drift
      if (heart.y < -20) Object.assign(heart, make(true))
      ctx.fillStyle = `rgba(255, 107, 239, ${heart.o})`
      heartPath(ctx, heart.x, heart.y, heart.s)
      ctx.fill()
    }
    raf = requestAnimationFrame(draw)
  }

  const observer = new ResizeObserver(resize)
  observer.observe(canvas.parentElement || document.body)
  resize()
  raf = requestAnimationFrame(draw)
  return () => {
    observer.disconnect()
    cancelAnimationFrame(raf)
  }
}
